module.exports = __webpack_public_path__ + "img/3.16781cc3.svg";